// Slovenské dvojče locale/cs/searchPage.js.
export default {
  more: 'Načítať ďalšie',
  morePrefix: 'Načítať ',
  moreFew: 'ďalšie ',
  moreMany: 'ďalších ',
  similar: 'Podobné skladom',
  similarSubCat: 'Skladom z kategórie ',
  similarSub: 'Skladom z rovnakých kategórií',
  similarPrev: 'Predchádzajúce produkty',
  similarNext: 'Ďalšie produkty',
  sortPrefix: 'Zoradiť: ',
  sortAria: 'Zoradenie výsledkov',
  sortLabels: {
    relevance: 'Zhoda',
    bestseller: 'Najpredávanejšie',
    price_asc: 'Najlacnejšie',
    price_desc: 'Najdrahšie',
    newest: 'Novinky',
  },
  productsHeading: 'Produkty',
};
